import React from 'react'
import {
  Card,
  CardContent,
  Typography,
  Box,
  MenuItem,
  Select,
  SelectChangeEvent,
  useTheme,
} from '@mui/material'
import { styled } from '@mui/material/styles'
import useCustomStyles from '../../hooks/CustomStylesHook'
import Colors from '../../utils/colors.json'

const styles = (theme: any) => ({
  card: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: theme.palette.primary.light,
    borderRadius: '20px',
    width: '100%',
  },
})

const Bar = styled('div')<{
  height: number
  isHighlighted: boolean
}>(({ theme, height, isHighlighted }) => ({
  width: '10%', // Adjusted for three bars per month
  height: `${height}%`,
  margin: theme.spacing(0.3),
  backgroundColor: isHighlighted
    ? theme.palette.primary.main
    : theme.palette.grey[300],
  borderRadius: theme.shape.borderRadius,
}))

const MonthContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '15%', // Adjusted for monthly groups
  margin: '0 4px',
})

const BarGroup = styled(Box)({
  display: 'flex',
  justifyContent: 'space-around',
  alignItems: 'flex-end',
  height: '7rem',
  width: '100%',
})

const ClaimsCard: React.FC = () => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)

  const [timeFrame, setTimeFrame] = React.useState('Year')

  const handleTimeFrameChange = (event: SelectChangeEvent) => {
    setTimeFrame(event.target.value)
  }

  // Simulated data: three bars for each month
  const barData = [
    { month: 'Jan', values: [30, 60, 85] },
    { month: 'Feb', values: [35, 55, 70] },
    { month: 'Mar', values: [30, 50, 85] },
    { month: 'Apr', values: [40, 35, 100], highlighted: true },
  ]

  return (
    <Card className={classes?.card} elevation={0}>
      <CardContent>
        <Box display='flex' justifyContent='space-between' alignItems='center'>
          <Typography
            variant='h6'
            fontWeight='bold'
            gutterBottom
            color={Colors.TEXT_COLOR_MAIN}
          >
            Claims
          </Typography>

          <Select
            value={timeFrame}
            onChange={handleTimeFrameChange}
            size='small'
            sx={{ fontSize: '0.7rem' }}
          >
            <MenuItem value='Year'>Year</MenuItem>
            <MenuItem value='Month'>Month</MenuItem>
            <MenuItem value='Week'>Week</MenuItem>
          </Select>
        </Box>
        <Box>
          <Typography variant='h5' fontWeight='bold'>
            ₹ 420,110
          </Typography>
        </Box>
        <Box
          display='flex'
          justifyContent='space-between'
          alignItems='center'
          mt={2}
        >
          {barData.map((month, index) => (
            <MonthContainer key={index}>
              <BarGroup>
                {month.values.map((value, idx) => (
                  <Bar
                    key={idx}
                    height={value}
                    isHighlighted={!!month.highlighted}
                  />
                ))}
              </BarGroup>
              <Typography variant='caption' color='textSecondary'>
                {month.month}
              </Typography>
            </MonthContainer>
          ))}
        </Box>
      </CardContent>
    </Card>
  )
}

export default ClaimsCard
